import * as yup from 'yup';
import { commonRules } from '../rules';

export const capturePhoneSchema = yup.object().shape({
  phoneNum: yup.string().matches(commonRules.REGEX.PHONE_WITH_PARENS, {
    excludeEmptyString: true,
  }),
});

export const confirmEmailValidationSchema = yup.object().shape({
  email: commonRules.email(),
  confirmEmail: commonRules.emailMatching('email'),
});

export const captureIdentityTOASSchema = yup.object().shape({
  fName: commonRules.firstNameMin2Chars,
  lName: commonRules.lastNameMin2Chars,
  dlNumber: commonRules.driverLicense,
  auditNum: commonRules.auditNumber,
  dob: commonRules.dob_dlr,
  ssn: commonRules.fullSSN,
  terms: commonRules.requiredCheckbox,
});

export const captureIdentityIDologySchema = yup.object().shape({
  fName: commonRules.firstNameMin2Chars,
  lName: commonRules.lastNameMin2Chars,
  streetAddress: commonRules.streetAddress,
  city: commonRules.city,
  state: commonRules.state,
  zipFive: commonRules.zipFive(),
  dob: commonRules.dob,
  lastFourSSN: commonRules.lastFourSSN,
  terms: commonRules.requiredCheckbox,
});

export const captureIdentityQuestionsSchema = yup.object().shape({
  answer: commonRules.identityQuestion,
});

export const homeAddressSchema = yup.object().shape({
  streetAddress: commonRules.streetAddress,
  addressLine2: commonRules.addressLine2,
  city: commonRules.city,
  state: commonRules.state,
  zipFive: commonRules.zipFive(),
});
